"use strict";

exports.__esModule = true;
exports.default = void 0;
var _getNative = _interopRequireDefault(require("./_getNative.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/* Built-in method references that are verified to be native. */
var nativeCreate = (0, _getNative.default)(Object, 'create');
var _default = exports.default = nativeCreate;